module.exports = __webpack_public_path__ + "img/pic2.f8a6be29.png";